import DetailFakturPenjualan from './DetailFakturPenjualan'

export default DetailFakturPenjualan